(function($) {

	'use strict';

	var init = function() {
		// Automatically close open menu/submenu on resize to avoid conflicts
		$(window).on('resize', function(){
			$('body').removeClass('menuOpen');
			$('.header__nav, .header__burger').removeClass('open');
			$('.header__nav__item__submenu.active').removeClass('active');
		})

		// Desktop animation
		$('.header__nav__item').on('mouseenter', function(){
			var item = $(this);
			var dotPos = item.offset().left + (item.innerWidth()/2) - $('.header__nav').offset().left;
			$('.header__nav__dot').css("left", dotPos);
		})
		$('.header__nav').on('mouseleave', function(){
			$('.header__nav__dot').css("left", "");
		})

		// Burger button
		$('.header__burger').on('click', function(){
			if(!$('.header__burger').hasClass('open')){
				switchSmallMenu(true);
				$('.header__burger').toggleClass('open');
			} else {
				$('.header__nav__item.mobileActive .header__nav__item__submenu').slideUp(300);
				$('.header__nav__item.mobileActive').removeClass('mobileActive')
				$('.header__burger').toggleClass('open');
				checkSticky();
			}
			$('.header__nav').toggleClass('open');
			$('body').toggleClass('menuOpen');
		});

		// Sticky menu size
		$(window).on('scroll', checkSticky);
		checkSticky();

		var timer;
		// Submenu open
		$('.header__nav__item__label').on('mouseenter', function(e){
			var submenu = $(this).siblings('.header__nav__item__submenu');
			timer = setTimeout(function() {
				if(window.innerWidth >= 992){
					var old_active = $('.header__nav__item__submenu.active');
					submenu.toggleClass('active');
					if(!$('body').hasClass('menuOpen')){
						$('body').toggleClass('menuOpen');
						old_active.removeClass('active');
						switchSmallMenu(true);
					} else {
						setTimeout(function(){
							old_active.removeClass('active');
							switchSmallMenu(true);
						}, 100);
					}
				} else {
					var nav_item = submenu.closest('.header__nav__item');
					if(nav_item.hasClass('mobileActive')){
						nav_item.removeClass('mobileActive');
						submenu.slideUp(300);
					} else {
						$('.header__nav__item.mobileActive .header__nav__item__submenu').slideUp(300);
						$('.header__nav__item.mobileActive').removeClass('mobileActive')
						nav_item.addClass('mobileActive');
						submenu.slideDown(300);
					}
				}
			}, 300);
		});

		$('.header__nav__item__label').on('focus', function(e){
			var submenu = $(this).siblings('.header__nav__item__submenu');
			timer = setTimeout(function() {
				if(window.innerWidth >= 992){
					var old_active = $('.header__nav__item__submenu.active');
					submenu.toggleClass('active');
					if(!$('body').hasClass('menuOpen')){
						$('body').toggleClass('menuOpen');
						old_active.removeClass('active');
						switchSmallMenu(true);
					} else {
						setTimeout(function(){
							old_active.removeClass('active');
							switchSmallMenu(true);
						}, 100);
					}
				} else {
					var nav_item = submenu.closest('.header__nav__item');
					if(nav_item.hasClass('mobileActive')){
						nav_item.removeClass('mobileActive');
						submenu.slideUp(300);
					} else {
						$('.header__nav__item.mobileActive .header__nav__item__submenu').slideUp(300);
						$('.header__nav__item.mobileActive').removeClass('mobileActive')
						nav_item.addClass('mobileActive');
						submenu.slideDown(300);
					}
				}
			}, 300);
		});

		$('.header__nav__item__label').on('mouseleave', function(e){
			if($('.header__nav__item__submenu.active').hasClass('active')) {
				return;
			}
			clearInterval(timer);
		});

		$('.header__nav__item__submenu').on('mouseleave', function(e){
			$('.header__nav__item__submenu.active').removeClass('active');
		});

		$('.submenu-panel__close').on('focusout', function(e){
			$('.header__nav__item__submenu.active').removeClass('active');
		});

		$('.header__logo').on('mouseenter', function(e){
			$('.header__nav__item__submenu.active').removeClass('active');
		});

		$('.header__resultsLink').on('mouseenter', function(e){
			$('.header__nav__item__submenu.active').removeClass('active');
		});

		// Submenu close
		$('.submenu-panel__close').on('click', function(e){
			var submenu = $(this).closest('.header__nav__item__submenu.active');
			submenu.removeClass('active');
			$('body').removeClass('menuOpen');
			checkSticky()
		});
	};

	var checkSticky = function(e){
        if( $(document).scrollTop() > 30 ){
			switchSmallMenu(true);
        } else{
			switchSmallMenu(false);
        }
	}
	
	var switchSmallMenu = function(small){
		if($('.header__nav__item__submenu.active').length <= 0 && !$('.header__burger').hasClass('open')){
			if( !$('.header').hasClass('small') && small ){
				$('.header').addClass('small');
				$('body').addClass('sticky-menu');
			} else if( $('.header').hasClass('small') && !small ){
				$('.header').removeClass('small');
				$('body').removeClass('sticky-menu');
			}
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
